import { useMemo } from "react";
import { object, bool } from "yup";

export type AcceptCGU = {
  acceptCGU: boolean;
};

const useValidationSchemaValidationCGU = () => {
  return useMemo(() => {
    const CGUNotAccepted = "form.error.cguNotAccepted";

    // Schema représentant l'ensemble des champs du formulaire
    // inclu la validation de ces champs si nécessaire
    const validationSchema = object<AcceptCGU>().shape({
      acceptCGU: bool().required(CGUNotAccepted).test("test-cgu", CGUNotAccepted, value => value === true),
    });
    return validationSchema;
  }, []);
};

export default useValidationSchemaValidationCGU;
